import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getInvoicePaymentMethods } from 'modules/_common/api';

export const useQueryInvoicePaymentMethods = ({ calculationId }: { calculationId: string }) => {
  return useQuery(
    [QUERY_KEYS.INVOICES_INVOICE_PAYMENT_METHODS, calculationId],
    () => getInvoicePaymentMethods({ calculationId }),
    {
      enabled: !!calculationId,
    },
  );
};
